import React from "react";
import { Link } from "react-router-dom";

const ReadytoGetStarted = ({ setuserContextState }) => {
  return (
    <section className="get-started-block">
      <div className="container">
        <h2>Ready to get started?</h2>
        <p>
          Amazing! Using WhatzOn is very easy. Just click on ‘Get Started’
          below, sign up and start using.
        </p>
        <Link
          to="/splash"
          className="get-started-btn"
          onClick={() => {
            setuserContextState((prevValue) => ({
              ...prevValue,
              route: "/onboarding",
            }));
          }}
        >
          Get Started
        </Link>
      </div>
    </section>
  );
};

export default ReadytoGetStarted;
